import PageableBase from 'app/collections/pageable_base';
import { appUrl } from 'utils/wrappers';
import Insurance from 'app/models/insurance';

export default PageableBase.extend({
  model: Insurance,
  key: 'insurances',
  url: appUrl('insurances'),
});



// WEBPACK FOOTER //
// ./app/collections/insurances.js